import React, { Component } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './HomeCarousel.css';

export default class PreviousNextMethods extends Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }
  render() {
    const settings = {
      infinite: true,
      speed: 100,
      slidesToShow: 1,
      slidesToScroll: 1,
      accessibility: true,
      adaptiveHeight: true,
      autoplay: true,
    };
    return (
      <div>
        <Slider ref={(c) => (this.slider = c)} {...settings}>
          {/* <div class="container"  key={1}>
            <img src="/pfw-images/vipmedcoe/MissionThanksgivingWeb.jpg" />
              <button class="btn">
              <h3>MEDCoE</h3>
              <h3 style={{padding:"0%", color: "PaleGoldenRod"}}>Mission Thanksgiving</h3>
              <p>Welcome soldiers to share in your Thanksgiving meal</p>
              <a href="/mission-thanksgiving">Learn More</a>
            </button>
          </div> */}
          {/* <div class="container"  key={1}>
            <img src="/pfw-images/vipmedcoe/HolidayBlockLeave.jpg" />
              <button class="btn">
              <h3>MEDCoE</h3>
              <h3 style={{padding:"0%", color: "PaleGoldenRod"}}>Holiday Block Leave</h3>
              <p>2024 Holiday Block Leave information & resources for travelers</p>
              <a href="https://medcoe.army.mil/holiday-block-leave">Learn More</a>
            </button>
          </div> */}
          {/* <div class="container"  key={1}>
            <img src="/pfw-images/vipmedcoe/execorder.png" />
          </div> */}
          <div class='container' key={1}>
            <StaticImage
              src='../../images/medevac-1.png'
              alt='medical evac'
              formats={['JPG']}
              layout='fullWidth'
            />
            {/* <img src='/pfw-images/vipmedcoe/medevac-1.png' alt='' /> */}
            <button class='btn'>
              <h3>MEDCoE</h3>
              <h3 style={{ padding: '0%', color: 'PaleGoldenRod' }}>Warriors Wanted</h3>
              <p>Find out if you have what it takes to join the Army</p>
              <a href='https://www.goarmy.com/'>Learn More</a>
            </button>
          </div>
          <div class='container' key={2}>
            <StaticImage
              src='../../images/endless.png'
              alt='endless'
              formats={['JPG']}
              layout='fullWidth'
            />
            {/* <img src='/pfw-images/vipmedcoe/endless.png' alt='' /> */}
            <button class='btn'>
              <h3>MEDCoE</h3>
              <h3 style={{ padding: '0%', color: 'PaleGoldenRod' }}>
                Endless Possibilities
              </h3>
              <p>Nearly 30,000 instructed in over 360 training and education programs</p>
              <a href='https://recruiting.army.mil/mrb/'>Learn More</a>
            </button>
          </div>
          <div class='container' key={3}>
            <StaticImage
              src='../../images/grad.png'
              alt='grad'
              formats={['JPG']}
              layout='fullWidth'
            />
            {/* <img src='/pfw-images/vipmedcoe/grad.png' alt='' /> */}
            <button class='btn'>
              <h3>MEDCoE</h3>
              <h3 style={{ color: 'PaleGoldenRod' }}>Graduations</h3>
              <p>
                Policies and tips to keep Soldiers & guests safe during open graduations
              </p>
              <a href='https://medcoe.army.mil/graduations'>Learn More</a>
            </button>
          </div>
          <div class='container' key={4}>
            <StaticImage
              src='../../images/learntechbanner.png'
              alt='learn tech'
              formats={['JPG']}
              layout='fullWidth'
            />
            {/* <img src='/pfw-images/vipmedcoe/learntechbanner.png' alt='' /> */}
            <button class='btn'>
              <h3>MEDCoE</h3>
              <h3 style={{ color: 'PaleGoldenRod' }}>Are You Ready to Learn Online</h3>
              <p>
                Tools, Tips, and Advice, to Help You Quickly Transition to Online Teaching
                and Learning
              </p>
              <a href='https://medcoe.army.mil/learn-tech'>Learn More</a>
            </button>
          </div>
          <div class='container' key={5}>
            <StaticImage
              src='../../images/medcon2020.png'
              alt='medcon 2020'
              formats={['JPG']}
              layout='fullWidth'
            />
            {/* <img src='/pfw-images/vipmedcoe/medcon2020.png' alt='' /> */}
            <button class='btn'>
              <h3>MEDCoE</h3>
              <h3 style={{ color: 'PaleGoldenRod' }}>Army Medicine Vision</h3>
              <p>
                Army Medicine of 2028 is ready, reformed, reorganized, responsive, and
                relevant
              </p>
              <a href='/pfw-images/dbimages/am-vision.pdf'>Learn More</a>
            </button>
          </div>
          <div class='container' key={6}>
            <StaticImage
              src='../../images/flag.jpg'
              alt='flag'
              formats={['JPG']}
              layout='fullWidth'
            />
            {/* <img src='/pfw-images/vipmedcoe/flag.png' alt='' /> */}
            <button class='btn'>
              <h3>MEDCoE</h3>
              <h3 style={{ color: 'PaleGoldenRod' }}>Army Medicine Starts Here!</h3>
              <p>We Develop Leaders and Drive Change</p>
              <a href='https://medcoe.army.mil/about-us'>Learn More</a>
            </button>
          </div>
          <div class='container' key={7}>
            <StaticImage
              src='../../images/21st-century.jpg'
              alt='21st century'
              formats={['JPG']}
              layout='fullWidth'
            />
            {/* <img src='/pfw-images/vipmedcoe/21st-century.jpg' alt='' /> */}
            <button class='btn'>
              <h3>MEDCoE</h3>
              <h3 style={{ color: 'PaleGoldenRod' }}>21st Century Institution</h3>
              <p>
                Largest Civilian-Accredited Service School with Programs Consistently Top
                10 Ranked Nationally
              </p>
              <a href='https://medcoe.army.mil/about-us#organizations'>Learn More</a>
            </button>
          </div>
          <div class='container' key={8}>
            <StaticImage
              src='../../images/medevac-2.jpg'
              alt='medical evac 2'
              formats={['JPG']}
              layout='fullWidth'
            />
            {/* <img src='/pfw-images/vipmedcoe/medevac-2.jpg' alt='' /> */}
            <button class='btn'>
              <h3>MEDCoE</h3>
              <h3 style={{ color: 'PaleGoldenRod' }}>Modern and Ready</h3>
              <p>Increasing the Army's Lethality through Soldier Survivability</p>
              <a href='https://medcoe.army.mil/about-us#mission'>Learn More</a>
            </button>
          </div>
          <div class='container' key={9}>
            <StaticImage
              src='../../images/acft.jpg'
              alt='acft'
              formats={['JPG']}
              layout='fullWidth'
            />
            {/* <img src='/pfw-images/vipmedcoe/acft.jpg' alt='' /> */}
            <button class='btn'>
              <h3>MEDCoE</h3>
              <h3 style={{ color: 'PaleGoldenRod' }}>ACFT</h3>
              <p>
                The Army Combat Fitness Test connects fitness with combat readiness for
                all Soldiers
              </p>
              <a href='https://www.army.mil/acft/'>Learn More</a>
            </button>
          </div>
          <div class='container' key={10}>
            <StaticImage
              src='../../images/cop.jpg'
              alt='cop'
              formats={['JPG']}
              layout='fullWidth'
            />
            {/* <img src='/pfw-images/vipmedcoe/cop.jpg' alt='' /> */}
            <button class='btn'>
              <h3>MEDCoE</h3>
              <h3 style={{ color: 'PaleGoldenRod' }}>Medical Common Operating Picture</h3>
              <p>
                Click the link to see how MEDCoE is transforming Army Medicine and setting
                a new standard in medical excellence
              </p>
              <a href='https://medcoe.army.mil/medcoe-cop-archive'>Learn More</a>
            </button>
          </div>
        </Slider>
        <div style={{ textAlign: 'center' }}>
          <ul class='usa-button-group usa-button-group--segmented'>
            <li style={{ marginLeft: '45%' }}>
              <button className='button' onClick={this.previous}>
                &#x276C;
              </button>
            </li>
            <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</li>
            <li style={{ marginRight: '45%' }}>
              <button className='button' onClick={this.next}>
                &#x276D;
              </button>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
